import settings from './settings.json';

export default {
  settings,
};
